import { Injectable } from '@angular/core';
import { OPS_PERMISSIONS, RECRUITMENT_PERMISSIONS } from '@shared/constants';

@Injectable({
	providedIn: 'root'
})
export class PortalAccessCheckService {
	hasRecruitmentPortalAccess(userPermissions: string[] = []): boolean {
		return userPermissions.some((permission) =>
			Object.values(RECRUITMENT_PERMISSIONS).includes(permission)
		);
	}

	hasOpsPortalAccess(userPermissions: string[] = []): boolean {
		return userPermissions.some((permission) =>
			Object.values(OPS_PERMISSIONS).includes(permission)
		);
	}
}
